import React from "react";
import "../css/privacy.scss";
import siteConfig from "../siteConfig";

function Faq() {
  return (
    <main className="policy">
      <header><p>GOOD TO KNOW</p><h1>Frequently asked questions</h1></header>
      <article>
        <h2>How much is delivery?</h2>
        <p>Standard delivery is a flat ${siteConfig.shipping.flatRate.toFixed(2)} USD per order.</p>
        <h2>When will my order be dispatched?</h2>
        <p>Orders are usually prepared within 1–2 business days. Tracking is emailed after collection.</p>
        <h2>Can I change or cancel an order?</h2>
        <p>Email us as soon as possible. If packing has not started, we will do our best to help.</p>
        <h2>What if an item arrives damaged?</h2>
        <p>Contact us within 48 hours with your order number and clear photographs of the item and packaging.</p>
        <h2>How do I contact teingshome?</h2>
        <p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p>
      </article>
    </main>
  );
}

export default Faq;
